<div class="section-header" mat-dialog-title>
  <mat-icon class="section-icon">list</mat-icon>
  <span class="section-title">tutorial list results</span>
  <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="response-container">
    <div class="summary-bar">
      <div class="summary-info">
        <mat-icon>list</mat-icon>
        <span>Found {{ data.count || 0 }} items</span>
      </div>
      <div class="action-buttons">
        <button mat-button (click)="copyToClipboard()" matTooltip="Copy as JSON">
          <mat-icon>content_copy</mat-icon>
          Copy JSON
        </button>
        <button mat-button (click)="exportAsCSV()" matTooltip="Export as CSV">
          <mat-icon>download</mat-icon>
          Export CSV
        </button>
      </div>
    </div>

    <div class="table-container">
      <div class="table-scroll-wrapper">
        <table mat-table [dataSource]="dataSource" matSort class="full-width">

          <!-- Checkbox Column -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="masterToggle()"
                [checked]="isAllSelected()"
                [indeterminate]="isSomeSelected()"
                color="primary">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()"
                (change)="toggleRow(row)"
                [checked]="isSelected(row)"
                color="primary">
              </mat-checkbox>
            </td>
          </ng-container>

          <!-- Video ID Column -->
          <ng-container matColumnDef="videoId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Video ID</th>
            <td mat-cell *matCellDef="let element" class="video-id-cell">
              @if (element.videoId) {
                <span class="selectable-text">{{ element.videoId }}</span>
              }
              @if (!element.videoId) {
                <span class="empty-value">-</span>
              }
            </td>
          </ng-container>

          <!-- Path Column -->
          <ng-container matColumnDef="path">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Subject</th>
            <td mat-cell *matCellDef="let element" class="path-cell" [title]="element.path">{{ element.path }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- No data row -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-data" colspan="3">No tutorials found</td>
          </tr>
        </table>
      </div>

      <!-- Paginator removed to show all items in scrollable list -->
      <!-- <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"
      [pageSize]="25"
      showFirstLastButtons>
    </mat-paginator> -->
  </div>
</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onOk()">OK</button>
</mat-dialog-actions>